import React, { useState } from 'react';
import { vars } from '../../theme';
import { Loader } from '../HBLoader/HBLoader.styles';
import {
    NewTableStyledTbody,
    NewTableLoaderContainer
} from './HBNewTable.styles';
import { INFINITE_SCROLL_THRESHOLD } from './HBNewTable.types';
import HBNewTableRow from './HBNewTableRow';
import HBNewTableInfiniteScroll from './HBNewTableInfiniteScroll';

const HBNewTableRowList = ({
    items,
    getItemId,
    columnDefinitions,
    selectableProps,
    infiniteScrollProps,
    expandableProps,
    hasSpacer
}) => {
    const [hoveredRowItemId, setHoveredRowItemId] = useState();

    const isSelectable = !!selectableProps;
    const isSelectableMode = selectableProps?.selectedItemIds?.length > 0;

    const itemsMap = (
        <>
            {items.map(item => {
                const itemId = getItemId(item);

                return (
                    <HBNewTableRow
                        key={itemId}
                        item={item}
                        columnDefinitions={columnDefinitions}
                        itemId={itemId}
                        isSelectable={isSelectable}
                        isSelectableMode={isSelectableMode}
                        expandableProps={expandableProps}
                        hasSpacer={hasSpacer}
                        isRowHovered={itemId === hoveredRowItemId}
                        setHoveredRowItemId={setHoveredRowItemId}
                    />
                );
            })}
        </>
    );

    const isWithInfi = !!infiniteScrollProps;

    return (
        <>
            {isWithInfi ? (
                <HBNewTableInfiniteScroll
                    element={NewTableStyledTbody}
                    hasMore={infiniteScrollProps.hasMore}
                    loadMore={infiniteScrollProps.loadMore}
                    threshold={
                        infiniteScrollProps.threshold ||
                        INFINITE_SCROLL_THRESHOLD
                    }
                    pageStart={infiniteScrollProps.pageStart}
                    columnCount={columnDefinitions.length}
                    loader={
                        infiniteScrollProps.loader || (
                            <NewTableLoaderContainer>
                                <Loader
                                    size="medium"
                                    color={vars.colors.base.accent}
                                />
                            </NewTableLoaderContainer>
                        )
                    }
                >
                    {itemsMap}
                </HBNewTableInfiniteScroll>
            ) : (
                <NewTableStyledTbody>{itemsMap}</NewTableStyledTbody>
            )}
        </>
    );
};

export default React.memo(HBNewTableRowList);
